import styled from 'styled-components'

const Spinner = styled.span`
  width: ${props => props.size || '24px'};
  height: ${props => props.size || '24px'};
  border: ${props => props.width || '4px'} solid
    ${props => props.color || 'var(--color-primary)'};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default Spinner
